import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export default function Table({ tableData, columns, style, scrollHeight }) {
    return (
        <div className="table-wrap">
            <DataTable
                value={tableData}
                scrollable
                scrollHeight={scrollHeight}
                className='custom-table'
                emptyMessage="No matching records found."
            >
                {columns?.map(col => (
                    <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={col.body}
                        sortable={col.sortable !== false}
                        headerClassName={col.headerClassName}
                        bodyClassName={col.bodyClassName}
                        style={{
                            width: col.width,
                        }}

                    />
                ))}
            </DataTable>
        </div>
    );
}